import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_program_participant_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    member_guid: fromDatatype.GuidDataFieldInterface;
    referral_source: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    date_effective: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mlm_program_participant_hdr_RowClass implements bl_mlm_program_participant_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    member_guid: fromDatatype.GuidDataFieldInterface;
    referral_source: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    date_effective: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}